import { useLocation, useParams } from 'react-router';

const useCustomerId = () => {
	const { customerId } = useParams();
	const location = useLocation();

	if (customerId) {
		return customerId;
	}

	return new URLSearchParams(location.search.toLowerCase()).get('customerid');
};

export default useCustomerId;
